











































import { computed, defineComponent } from '@vue/composition-api';
import { Dialog, Button } from 'element-ui';

export default defineComponent({
  name: 'Dialog',
  props: {
    title: {
      type: String,
      defalut: '',
    },
    width: {
      type: [String, Number],
      default: '1000px',
    },
    show: {
      type: Boolean,
      default: false,
    },
    destroyOnClose: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    modal: {
      type: Boolean,
      default: true,
    },
    body: {
      type: Boolean,
      default: false,
    },
    dialogBtns: {
      type: Array,
      default: () => null,
    },
    dialogType: {
      type: String,
      default: '',
    },
    dialogText: {
      type: String,
      default: '',
    },
  },
  components: {
    't-dialog': Dialog,
    't-button': Button,
  },
  setup(props: any, { emit }) {
    const visible = computed(() => props.show);

    const onClose = () => {
      emit('handleClose');
    };

    const onOpen = () => {
      emit('handleOpen');
    };

    return { visible, onClose, onOpen };
  },
});
